export default __webpack_public_path__ + "static/media/joshuaTree.f634bc11.JPG";